import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Redirect} from 'react-router-dom'

import mustBeLogged from '../../../components/Must/MustBeLogged.jsx'
import mustHaveAcceptedCGU from '../../../components/Must/MustHaveAcceptedCGU.jsx'
import StrategyFreelanceContainer from '../StrategyFreelanceContainer.jsx'
import withCurrentUniverse, {CURRENT_USER_PRIORITY} from '../../../HOC/withCurrentUniverse.jsx'

import actions from '../../../components/CurrentUserLoader/actions.js'
import conf from '../../../../shared/conf.js'

import CvDataComparisonStepView from './CvDataComparisonStepView.jsx'

class CvDataComparisonStepContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, location, history} = this.props

    if (!endLoadingCurrentUser) {
      return null
    }

    if (!location.state || !location.state.analyse) {
      return <Redirect to="/create/freelance" />
    }

    const currentStep = 2

    return <StrategyFreelanceContainer
      currentStep={currentStep}
      currentUser={currentUser}
      loading={!endLoadingCurrentUser}
      profile={{user: currentUser, freelance: currentFreelance}}
      view={CvDataComparisonStepView}
      analyse={location.state.analyse}
      history={history}
    />
  }
}

export default connect(
  (state) => ({
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(
  withCurrentUniverse(
    mustBeLogged(
      mustHaveAcceptedCGU(CvDataComparisonStepContainer),
      conf.accountTypes.freelance
    ),
    CURRENT_USER_PRIORITY
  )
)
